module.exports = __webpack_public_path__ + "img/beijing.2e4b0ba9.jpg";